<template>
    <div class="reward-modal-overlay">
        <div class="reward-card">
            <!-- 关闭按钮 -->
            <img
                class="closed"
                @click="close"
                src="../../../assets/imgs/public/close.png"
                alt="关闭"
            />

            <!-- 标题 -->
            <div class="modal-title">
                <span>排行奖励</span>
            </div>

            <!-- Tab 切换 -->
            <div class="tab-header">
                <div
                    class="tab-item"
                    :class="{ active: currentTab === 'lover' }"
                    @click="switchTab('lover')"
                >
                    <span>情侣榜奖励</span>
                </div>

                <div
                    class="tab-item"
                    :class="{ active: currentTab === 'bestie' }"
                    @click="switchTab('bestie')"
                >
                    <span>闺蜜榜奖励</span>
                </div>
            </div>

            <!-- 奖励列表 -->
            <div class="reward-content">
                <!-- 表头 -->
                <div class="table-header">
                    <div class="col-rank">排名</div>
                    <div class="col-title">称号奖励</div>
                </div>

                <!-- 表格内容 -->
                <div class="table-body">
                    <div
                        class="table-row"
                        v-for="(item, index) in rewardList"
                        :key="`${currentTab}-${index}`"
                    >
                        <!-- 排名 -->
                        <div class="col-rank">
                            <span>{{ item.rankText }}</span>
                        </div>

                        <!-- 称号 -->
                        <div class="col-title">
                            <el-image
                                class="title-img"
                                :src="item.titleImg"
                                :preview-src-list="[item.titleImg]"
                                fit="contain"
                            >
                            </el-image>
                        </div>
                    </div>
                </div>

                <!-- 活动规则 -->
                <div class="rules">
                    <div class="rules-title">
                        <span class="rules-line"></span>
                        <span>奖励说明</span>
                        <span class="rules-line"></span>
                    </div>

                    <div class="rules-content">
                        <div
                            class="rule-item"
                            v-for="(rule, index) in rules"
                            :key="index"
                        >
                            <span class="rule-index">{{ index + 1 }}.</span>
                            <span class="rule-text">{{ rule }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 底部提示 -->
            <div class="tip">
                <span class="tip-icon">✦</span>
                <span>点击称号图片可查看大图</span>
                <span class="tip-icon">✦</span>
            </div>
        </div>
    </div>
</template>

<script>
// 情侣榜称号
import titleQueQiaoXian from "../../../assets/imgs/Qixi/Ranking/COUPLE1.png";
import titleNiuLangZhiNu from "../../../assets/imgs/Qixi/Ranking/COUPLE2.png";
import titleQiXiJiaRen from "../../../assets/imgs/Qixi/Ranking/COUPLE3.png";

// 闺蜜榜称号
import titleJinLanQi from "../../../assets/imgs/Qixi/Ranking/SISTER1.png";
import titleBingDiLian from "../../../assets/imgs/Qixi/Ranking/SISTER2.png";
import titleZhiXinRen from "../../../assets/imgs/Qixi/Ranking/SISTER3.png";

export default {
    name: "RewardModal",

    data() {
        return {
            // 当前 Tab
            currentTab: "lover",

            // 活动规则
            rules: [
                "排行榜分为情侣排行和闺蜜排行，排行依据为活动期间通过七夕相关活动累计获得的情侣红心或蜜糖之心数量，不包含泡点兑换以及历史情侣红心、蜜糖之心数据。",
                "活动结束后，排行前十的情侣或闺蜜可获得七夕限定称号；两榜第一名额外获得全服唯一七夕特权称号。",
                "两榜前三名可获得歌曲定制权，定制数量 = 活动期间消费白金币金额 ÷ 1000 × 5，最终结果向下取整。",
                "两榜第一名还可获得两套服饰定制权（两榜分开计算），以及情侣戒指或闺蜜戒指定制一枚。"
            ]
        };
    },

    computed: {
        /**
         * 当前榜单奖励
         */
        rewardList() {
            const loverRewards = [
                {
                    rankText: "TOP 1",
                    titleImg: titleQueQiaoXian
                },
                {
                    rankText: "TOP 2-3",
                    titleImg: titleNiuLangZhiNu
                },
                {
                    rankText: "TOP 4-10",
                    titleImg: titleQiXiJiaRen
                }
            ];

            const bestieRewards = [
                {
                    rankText: "TOP 1",
                    titleImg: titleJinLanQi
                },
                {
                    rankText: "TOP 2-3",
                    titleImg: titleBingDiLian
                },
                {
                    rankText: "TOP 4-10",
                    titleImg: titleZhiXinRen
                }
            ];

            return this.currentTab === "lover"
                ? loverRewards
                : bestieRewards;
        }
    },

    methods: {
        /**
         * 切换榜单
         */
        switchTab(tab) {
            if (this.currentTab === tab) {
                return;
            }

            this.currentTab = tab;
        },

        /**
         * 关闭弹窗
         */
        close() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="less" scoped>
.reward-modal-overlay {
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    // height: calc(100% - 120px);
    height: 630px;

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 2000;

    box-sizing: border-box;
}

.reward-card {
    position: relative;

    width: 500px;
    height: 630px;

    padding: 22px 30px 41px;

    box-sizing: border-box;

    display: flex;
    flex-direction: column;

    background-image: url("../../../assets/imgs/Qixi/Raningbg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    color: #ffffff;

    /* ==================== */
    /* 关闭按钮 */
    /* ==================== */

    .closed {
        position: absolute;

        top: -38px;
        right: -58px;

        width: 70px;
        height: 70px;

        cursor: pointer;

        z-index: 20;

        transition: transform 0.2s ease;

        &:hover {
            transform: rotate(90deg) scale(1.05);
        }

        &:active {
            transform: rotate(90deg) scale(0.95);
        }
    }

    /* ==================== */
    /* 顶部标题 */
    /* ==================== */

    .modal-title {
        height: 32px;

        display: flex;
        align-items: center;
        justify-content: center;

        margin-bottom: 10px;

        font-size: 18px;
        font-weight: bold;
        color: #ffffff;

        letter-spacing: 2px;

        text-shadow:
            0 2px 5px rgba(122, 30, 75, 0.8),
            0 0 8px rgba(255, 190, 220, 0.7);

        span {
            position: relative;

            padding: 0 18px;

            &::before,
            &::after {
                content: "";

                position: absolute;

                top: 50%;

                width: 28px;
                height: 1px;

                background: linear-gradient(
                    to right,
                    transparent,
                    rgba(255, 255, 255, 0.8)
                );
            }

            &::before {
                right: 100%;
            }

            &::after {
                left: 100%;

                transform: rotate(180deg);
            }
        }
    }

    /* ==================== */
    /* Tab */
    /* ==================== */

    .tab-header {
        width: 100%;

        height: 42px;

        display: flex;
        align-items: center;
        justify-content: center;

        gap: 60px;

        margin-bottom: 12px;

        border-bottom: 1px solid rgba(255, 255, 255, 0.15);

        .tab-item {
            position: relative;

            height: 42px;

            display: flex;
            align-items: center;
            justify-content: center;

            padding: 0 8px;

            box-sizing: border-box;

            font-size: 14px;
            font-weight: bold;

            color: rgba(255, 255, 255, 0.55);

            cursor: pointer;

            transition:
                color 0.2s ease,
                text-shadow 0.2s ease;

            &::after {
                content: "";

                position: absolute;

                left: 50%;
                bottom: -1px;

                width: 0;
                height: 3px;

                transform: translateX(-50%);

                border-radius: 3px;

                background: #ffffff;

                box-shadow:
                    0 0 5px rgba(255, 255, 255, 0.8),
                    0 0 10px rgba(255, 170, 210, 0.8);

                transition: width 0.25s ease;
            }

            &:hover {
                color: rgba(255, 255, 255, 0.9);
            }

            &.active {
                color: #ffffff;

                text-shadow:
                    0 0 6px rgba(255, 255, 255, 0.8),
                    0 0 12px rgba(255, 170, 210, 0.7);

                &::after {
                    width: 36px;
                }
            }
        }
    }

    /* ==================== */
    /* 主体 */
    /* ==================== */

    .reward-content {
        flex: 1;

        min-height: 0;

        display: flex;
        flex-direction: column;
    }

    /* ==================== */
    /* 表头 */
    /* ==================== */

    .table-header {
        flex-shrink: 0;

        height: 38px;

        display: flex;
        align-items: center;

        box-sizing: border-box;

        border-bottom: 1px solid rgba(255, 255, 255, 0.25);

        font-size: 13px;
        font-weight: bold;

        color: rgba(255, 255, 255, 0.9);

        .col-rank {
            width: 35%;

            text-align: center;
        }

        .col-title {
            width: 65%;

            text-align: center;
        }
    }

    /* ==================== */
    /* 表格内容 */
    /* ==================== */

    .table-body {
        flex-shrink: 0;

        width: 100%;
    }

    .table-row {
        display: flex;
        align-items: center;

        min-height: 70px;

        box-sizing: border-box;

        border-bottom: 1px dashed rgba(255, 255, 255, 0.16);

        transition:
            background-color 0.2s ease,
            transform 0.2s ease;

        &:hover {
            background: rgba(255, 255, 255, 0.035);

            .title-img {
                transform: scale(1.05);
            }
        }

        .col-rank {
            width: 35%;

            display: flex;
            justify-content: center;
            align-items: center;

            font-size: 14px;
            font-weight: bold;

            color: #ffe680;

            text-shadow:
                0 1px 3px rgba(100, 40, 0, 0.6),
                0 0 6px rgba(255, 220, 100, 0.3);
        }

        .col-title {
            width: 65%;

            display: flex;
            justify-content: center;
            align-items: center;

            .title-img {
                display: block;

                width: 150px;
                height: 38px;

                object-fit: contain;

                cursor: pointer;

                transition: transform 0.2s ease;

                /deep/ img {
                    object-fit: contain;
                }
            }
        }
    }

    /* ==================== */
    /* 奖励说明 */
    /* ==================== */

    .rules {
        flex: 1;

        min-height: 0;

        margin-top: 15px;

        padding: 0 4px;

        box-sizing: border-box;

        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 3px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.25);

            border-radius: 3px;
        }

        .rules-title {
            display: flex;
            align-items: center;
            justify-content: center;

            gap: 8px;

            margin-bottom: 10px;

            font-size: 14px;
            font-weight: bold;

            color: #ffffff;

            .rules-line {
                width: 30px;
                height: 1px;

                background: linear-gradient(
                    to right,
                    transparent,
                    rgba(255, 255, 255, 0.5)
                );

                &:last-child {
                    transform: rotate(180deg);
                }
            }
        }

        .rules-content {
            width: 100%;
        }

        .rule-item {
            display: flex;

            margin-bottom: 8px;

            font-size: 12px;
            line-height: 1.7;

            color: rgba(255, 255, 255, 0.68);

            &:last-child {
                margin-bottom: 0;
            }

            .rule-index {
                flex-shrink: 0;

                width: 20px;

                color: #ffe680;

                font-weight: bold;
            }

            .rule-text {
                flex: 1;

                text-align: left;

                word-break: break-all;
            }
        }
    }

    /* ==================== */
    /* 底部提示 */
    /* ==================== */

    .tip {
        flex-shrink: 0;

        display: flex;
        justify-content: center;
        align-items: center;

        margin-top: 10px;

        font-size: 11px;

        color: rgba(255, 255, 255, 0.45);

        user-select: none;

        .tip-icon {
            margin-right: 5px;

            color: #ffe680;

            font-size: 12px;
        }
    }
}
</style>